(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var modal = document.getElementById('RentalCompatibilityModal');
    var modalTitle = document.getElementById('RentalCompatibilityModalTitle');
    var modalBody = document.getElementById('RentalCompatibilityModalBody');

    if (!modal || !modalTitle || !modalBody) return;

    var lastFocusedElement = null;

    var rentalPageConfig = window.PlayforceRentalConfig || {};
    var isMacbookCompatibilityGuide = Boolean(rentalPageConfig.isMacbookCompatibilityGuide);

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var compatibilityDetails = {
      'cloud-ai': {
        title: 'Cloud-Assisted AI Apps',
        description: 'Suitable for common cloud-based AI tools such as Canva, ChatGPT, Gemini, and Copilot in browser.',
        examples: ['Canva', 'ChatGPT in browser', 'Gemini', 'Copilot', 'Notion AI'],
        note: 'Performance may vary with heavier web apps, large files, or multiple tabs.'
      },
      'application-ai': {
        title: 'Application-Based AI Apps',
        description: 'Suitable for common AI apps that run on the laptop.',
        examples: ['ChatGPT desktop app', 'Copilot app', 'LM Studio', 'Ollama', 'Other installed AI tools'],
        note: 'Heavier AI use may require a higher-spec model depending on the app and how it is used.'
      },
      'adobe': {
        title: 'Adobe / Design Apps',
        description: 'Suitable for common Adobe and design apps such as Photoshop, Illustrator, Lightroom, and Canva.',
        examples: ['Photoshop', 'Illustrator', 'Lightroom', 'Premiere Pro', 'InDesign'],
        note: 'Heavier design work, large files, or video editing may require a higher-spec model.'
      },
      'python-coding': {
        title: 'Python / Coding',
        description: 'Suitable for common Python learning, coding, school projects, and development use.',
        examples: ['Python', 'Jupyter Notebook', 'PyCharm', 'Anaconda', 'VS Code'],
        note: 'Heavier coding projects, AI work, or multiple tools running together may require a higher-spec model.'
      },
      'visual-studio': {
        title: 'Visual Studio / VS Code',
        description: 'Suitable for common coding work on Visual Studio, VS Code, and similar development tools.',
        examples: ['Visual Studio Code', 'Visual Studio', '.NET', 'C# projects', 'Web development'],
        note: 'Larger projects, heavier builds, or multiple development tools running together may require a higher-spec model.'
      },
      'docker': {
        title: 'Docker',
        description: 'Suitable for general Docker use.',
        examples: ['Docker Desktop', 'Containers', 'WSL 2', 'Local development stacks'],
        note: 'Heavier projects or multiple containers may require a higher-spec laptop.'
      },
      'microsoft-office': {
        title: 'Microsoft Office',
        description: 'Suitable for common Microsoft Office use such as Word, Excel, PowerPoint, and Outlook.',
        examples: ['Word', 'Excel', 'PowerPoint', 'Outlook', 'OneNote'],
        note: 'Very large Excel files, heavy formulas, or multiple Office files open at once may perform better on a higher-spec model.'
      },
      'video-conferencing': {
        title: 'Zoom / Teams / Meet',
        description: 'Suitable for common video meetings, online classes, webinars, and screen sharing.',
        examples: ['Zoom', 'Microsoft Teams', 'Google Meet', 'Webex'],
        note: 'Performance may vary if many apps, browser tabs, or background programs are running at the same time.'
      },
      'web-browsers': {
        title: 'Web Browsers',
        description: 'Suitable for common browser-based tools and online platforms.',
        examples: ['Google Chrome', 'Microsoft Edge', 'Firefox', 'Web-based dashboards'],
        note: 'Performance may vary with multiple tabs or heavier web apps.'
      },
      'sql-database': {
        title: 'SQL / Database Tools',
        description: 'Suitable for common SQL tools, database clients, and local development databases.',
        examples: ['SQL Server Management Studio', 'MySQL Workbench', 'DBeaver', 'PostgreSQL', 'SQLite'],
        note: 'Larger databases, local servers, or multi-service projects may require a higher-spec model.'
      },
      'exam-browser': {
        title: 'Exam Browser & LockDown',
        description: 'Suitable for common online exam browsers and school assessment platforms.',
        examples: ['Safe Exam Browser', 'Respondus LockDown Browser', 'School exam browsers'],
        note: 'Please ensure your school or exam provider’s minimum requirements are met.'
      },
      'ubuntu': {
        title: 'Ubuntu / Custom OS',
        description: 'Suitable for users who need Ubuntu or custom OS installation for their own use.',
        examples: ['Ubuntu', 'Linux', 'Dual boot', 'Custom OS setup'],
        note: 'Custom OS may be installed if required, but the device must be returned with the original Windows OS intact.'
      }
    };

    if (isMacbookCompatibilityGuide) {
      compatibilityDetails['cloud-ai'].description = 'Suitable for common cloud-based AI tools such as Canva, ChatGPT, Gemini, and Copilot in browser.';
      compatibilityDetails['cloud-ai'].note = 'For heavier web apps, large files, or many tabs, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['application-ai'].description = 'Suitable for common AI apps that run on the MacBook.';
      compatibilityDetails['application-ai'].note = 'For heavier AI use or local AI tools, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['adobe'].description = 'Suitable for common Adobe and design apps such as Photoshop, Illustrator, Lightroom, and Canva.';
      compatibilityDetails['adobe'].note = 'For heavier design work, large files, or video editing, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['python-coding'].description = 'Suitable for common Python learning, coding, school projects, and development use.';
      compatibilityDetails['python-coding'].note = 'For heavier coding projects or multiple tools running together, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['visual-studio'].description = 'Suitable for common coding work on VS Code and similar development tools.';
      compatibilityDetails['visual-studio'].note = 'For larger projects or heavier development use, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['docker'].description = 'Suitable for general Docker use and development work.';
      compatibilityDetails['docker'].note = 'For heavier projects or multiple containers, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['microsoft-office'].description = 'Suitable for common Microsoft Office use such as Word, Excel, PowerPoint, and Outlook.';
      compatibilityDetails['microsoft-office'].note = 'For very large Excel files, heavy formulas, or multiple Office files open at once, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['video-conferencing'].description = 'Suitable for common video meetings, online classes, webinars, and screen sharing.';
      compatibilityDetails['video-conferencing'].note = 'Performance may vary if many apps, browser tabs, or background programs are running at the same time.';

      compatibilityDetails['web-browsers'].description = 'Suitable for common browser-based tools and online platforms.';
      compatibilityDetails['web-browsers'].note = 'For heavier web apps or many tabs, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['sql-database'].description = 'Suitable for common SQL tools, database clients, and local development databases.';
      compatibilityDetails['sql-database'].note = 'For larger databases, local servers, or heavier projects, we recommend choosing a MacBook with 16GB memory or higher.';

      compatibilityDetails['exam-browser'].description = 'Suitable for common online exam browsers and school assessment platforms.';
      compatibilityDetails['exam-browser'].note = '';

      compatibilityDetails['ubuntu'].description = 'Custom OS installation is not recommended for MacBook rentals.';
      compatibilityDetails['ubuntu'].note = 'The device must be returned with the original macOS intact.';
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function renderCompatibilityDetails(details) {
      var examplesHtml = details.examples.map(function (example) {
        return '<li>' + escapeHtml(example) + '</li>';
      }).join('');

      return '' +
        '<p>' + escapeHtml(details.description) + '</p>' +
        '<div class="rental-compatibility-modal-section">' +
          '<strong>Common examples</strong>' +
          '<ul class="rental-document-checklist rental-compatibility-example-list">' + examplesHtml + '</ul>' +
        '</div>' +
        (details.note ? '<div class="rental-document-privacy-note">' + escapeHtml(details.note) + '</div>' : '');
    }

    function openCompatibilityModal(trigger) {
      var key = trigger.getAttribute('data-rental-compatibility');
      var details = compatibilityDetails[key];

      if (!details) return;

      lastFocusedElement = trigger;
      modalTitle.textContent = details.title;
      modalBody.innerHTML = renderCompatibilityDetails(details);

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rental-modal-open');
      document.body.classList.add('rental-modal-open');

      var closeButton = modal.querySelector('[data-rental-compatibility-modal-close]');
      if (closeButton) closeButton.focus();
    }

    function closeCompatibilityModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rental-modal-open');
      document.body.classList.remove('rental-modal-open');

      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-rental-compatibility]');

      if (trigger) {
        event.preventDefault();
        if (
          trigger.disabled ||
          trigger.getAttribute('data-rental-compatibility-limited') === 'true' ||
          trigger.classList.contains('is-compatibility-limited')
        ) {
          return;
        }
        openCompatibilityModal(trigger);
        return;
      }

      if (
        event.target === modal ||
        event.target.closest('[data-rental-compatibility-modal-close]')
      ) {
        closeCompatibilityModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeCompatibilityModal();
      }
    });
  });
})();
